import React, { useEffect, useState } from "react";
import NavbarHeader from "../../../Navbarheader/NavbarHeader";
import Footer from "../../../Footer/Footer";
import HeroSection from "./components/Herosection";
import Intro from "./components/Intro";
import Moreintro from "./components/Moreintro";
import Styleguide from "./components/Styleguide";
import Tabmockup from "./components/Tabmockup";
import Twofacemockup from "./components/Twofacemockup";
import Bannermockup from "./components/Bannermockup";
import Multiplemockup from "./components/Multiplemockup";
import Multiplemockup2 from "./components/Multiplemockup2";
import Webmockup from "./components/Webmockup";

import NextProjectButton from "../components/NextProjectButton";

import { useNavigate } from 'react-router-dom';

function Edgemarketing() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
 const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleNextProjectClick = () => {
    navigate('/project/adept');
  };

  

  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        style={{
          backgroundColor: "#101010",
          paddingTop: isSmallScreen ? "7rem" : "0px",
        }}
      >
        <HeroSection />
        <Intro />
        <Moreintro />
        <Styleguide />
        <Tabmockup />
        <Twofacemockup />
        <Bannermockup />
        <Multiplemockup />
        <Multiplemockup2 />
        <Twofacemockup />
        <div id="showNextButton">
          <Webmockup />
        </div>
      </div>
      <Footer />

      <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />

     
    </div>
  );
}

export default Edgemarketing;
